const ViewEpibolyApply = () => import('../modules/xmsb/energy/operators/ViewEpibolyApplyGzl')

export default [
  {

    path: '/epibolyapplyview',
    name: 'epibolyapplyview',
    component: ViewEpibolyApply,
    meta: {
      title: '2019年市级商务发展专项资金（服务外包项目）- 离岸外包项目',
      fullscreen: true,
    },
  },
]
